"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WelcomeToFourDharmaFriends() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.3;
  return <section className="relative h-screen w-full overflow-hidden bg-light-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-75 ease-linear" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/sunrise_forest_clearing_hero.png)",
      transform: `translateY(${parallaxOffset}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-dark-background/30" />

      {}
      <div ref={contentRef} className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        {}
        <h1 className={`font-display text-4xl font-bold text-foreground-dark transition-all duration-700 ease-out-back md:text-5xl lg:text-6xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
        transitionDelay: "200ms"
      }}>
          Welcome to Four Dharma Friends
        </h1>

        {}
        <p className={`mt-6 max-w-2xl font-sans text-lg text-foreground-dark/90 transition-all duration-700 ease-out-back md:text-2xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
        transitionDelay: "400ms"
      }}>"Good friends, companions, and associates are the whole of the spiritual life." -- SN 45.2 Upaḍḍha Sutta</p>

        {}
        <div className={`mt-10 transition-all duration-700 ease-out-back ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
        transitionDelay: "600ms"
      }}>
          <Link to="/TeachersPage">
            
          </Link>
        </div>
      </div>
    </section>;
}